import { getItemWebStorage, setItemSessionStorage, setItemWebStorage } from "../../../../features/webStorageSaver"
import { setAreaMeasurementIsEnabled, setContentHeaderIsExpanded, setCopyCoordsButtonIsClicked, setGoToYandexMirrorsButtonIsClicked, setHighContrastModeIsEnabled, setNavigateToPanoButtonIsClicked, setPanoramaUnderMapIsShown, setPerimeterMeasurementIsEnabled, setRosreestrIsAvailable, setRosreestrIsEnabled, setSearchLineIsShown, setShowUserLocationButtonIsClicked, setTableUnderMapIsShown } from "../../../../stateManagement/reducers/ContentHeaderSlice"
import { setMapTooltipIsEnabled } from "../../../../stateManagement/reducers/MapTooltipSlice"
import { store } from "../../../../stateManagement/store"
import { browserHasRuCertificate } from "../../../map/mapFeatures/mapFunctions/rosreestrFunctions/rosreestrFunctions"

export function controlRosreestrSettingsButton() {
    if (browserHasRuCertificate()) {
        const rosreestrIsEnabled = store.getState().contentHeader.rosreestrIsEnabled
        store.dispatch(setRosreestrIsEnabled(!rosreestrIsEnabled))
        const currentMapSettingsState = getItemWebStorage('mapSettings')
        const newMapSettingsState = {
            ...currentMapSettingsState,
            rosreestrIsEnabled: !rosreestrIsEnabled
        }
        setItemWebStorage('mapSettings', newMapSettingsState)
    } else {
        store.dispatch(setRosreestrIsAvailable(false))
        return false
    }
}

export function controlTableUnderMapButton() {
    const { tableUnderMapIsShown, contentHeaderIsExpanded } = store.getState().contentHeader ?? {}
    store.dispatch(setTableUnderMapIsShown(!tableUnderMapIsShown));
    if (window.innerWidth < 768) setContentHeaderIsExpanded(!contentHeaderIsExpanded)
}

export function controlPerimeterMeasurementButton() {
    const perimeterMeasurementIsEnabled = store.getState().contentHeader.perimeterMeasurementIsEnabled
    store.dispatch(setPerimeterMeasurementIsEnabled(!perimeterMeasurementIsEnabled))
}

export function controlAreaMeasurementButton() {
    const areaMeasurementIsEnabled = store.getState().contentHeader.areaMeasurementIsEnabled
    store.dispatch(setAreaMeasurementIsEnabled(!areaMeasurementIsEnabled))
}

export function controlNavigateToPanoButton() {
    store.dispatch(setNavigateToPanoButtonIsClicked(true))
}

export function controlShowUserLocationButton() {
    const showUserLocationButtonIsClicked = store.getState().contentHeader.showUserLocationButtonIsClicked
    store.dispatch(setShowUserLocationButtonIsClicked(!showUserLocationButtonIsClicked))
}

export function controlMapSettingsButton(navigate: any) {
    navigate('/app/mapSettings/map')
}

export function controlCopyCoordsButton() {
    const copyCoordsButtonIsClicked = store.getState().contentHeader.copyCoordsButtonIsClicked
    store.dispatch(setCopyCoordsButtonIsClicked(!copyCoordsButtonIsClicked))
}

export function controlGoToYandexMirrorsButton() {
    const goToYandexMirrorsButtonIsClicked = store.getState().contentHeader.goToYandexMirrorsButtonIsClicked
    store.dispatch(setGoToYandexMirrorsButtonIsClicked(!goToYandexMirrorsButtonIsClicked))
}

export function controlHighContrastModeButton() {
    const highContrastModeIsEnabled = store.getState().contentHeader.highContrastModeIsEnabled
    const { auxiliaryLayersDisplayState } = getItemWebStorage("mapSettings") ?? {}
    const { indorAvia: indorAviaLayerIsShown, bing: bingLayerIsShown } = auxiliaryLayersDisplayState ?? {}
    if (!indorAviaLayerIsShown && !bingLayerIsShown) {
        setItemSessionStorage('mapHighContrastModeIsEnabled', !highContrastModeIsEnabled)
        store.dispatch(setHighContrastModeIsEnabled(!highContrastModeIsEnabled))
    }
}

export function controlSearchLineButton() {
    const searchLineIsShown = store.getState().contentHeader.searchLineIsShown
    store.dispatch(setSearchLineIsShown(!searchLineIsShown))
}

export function controlMapTooltipButton() {
    const mapTooltipIsEnabled = store.getState().mapTooltip.mapTooltipIsEnabled
    store.dispatch(setMapTooltipIsEnabled(!mapTooltipIsEnabled))
}

export function controlPanoramaUnderMapButton() {
    const panoramaUnderMapIsShown = store.getState().contentHeader.panoramaUnderMapIsShown
    store.dispatch(setPanoramaUnderMapIsShown(!panoramaUnderMapIsShown))
}

export function controlPathNormativitiesFilterButton(navigate: any) {
    navigate('/app/map/PathNormativities/filters')
}

export function controlPathNormativitiesGroupFilterButton(navigate: any) {
    navigate('/app/map/PathNormativities/group/filters')
}

export function controlRoadDiagnosticsSegmentsFilterButton(navigate: any) {
    navigate('/app/map/RoadDiagnosticsSegments/filters')
}

export function controlRoadAccidentSegmentsFilterButton(navigate: any) {
    navigate('/app/map/RoadAccidentSegments/filters')
}